import { render, staticRenderFns } from "./MyQna.vue?vue&type=template&id=49428dd1&"
import script from "./MyQna.vue?vue&type=script&lang=js&"
export * from "./MyQna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports